import { SagaIterator } from 'redux-saga';
import axios from 'axios';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import {
  setMySubmissionsSortBy,
  setMySubmissionsIsLoading,
  setMySubmissionsStats,
} from '../actions/statsSection';
import { API_BASE_PATH } from '../../constants';
import { getProfileOwnerUser } from '../selectors/users';

function fetchFromApi(requestUrl, params) {
  return axios
    .get(`${API_BASE_PATH}/${requestUrl}`, { params })
    .catch(response => false);
}

export function* setMySubmissionsSortBySaga(
  action: ReturnType<typeof setMySubmissionsSortBy>
): SagaIterator {
  const { payload: sortBy } = action;
  const profileOwnerUser = yield select(getProfileOwnerUser);

  yield put(setMySubmissionsIsLoading(true));

  const params = {
    username: profileOwnerUser.username,
    sort_by: sortBy,
  };

  const result = yield call(fetchFromApi, '/stats/my_content', params);

  if (result && result.data) {
    yield all([
      put(setMySubmissionsStats(result.data.myContent)),
      put(setMySubmissionsIsLoading(false)),
    ]);
  }
}

export default function* statsSectionSaga() {
  yield all([takeEvery(setMySubmissionsSortBy, setMySubmissionsSortBySaga)]);
}
